!function (global) {
  'use strict';

  // Capture context global variable.
  var previouscallOverwritingUrl = global.OverwritingUrl;

  // Global function for working with current url.
  function OverwritingUrl(options) {

    // Init for overwriting url.
    function init() {
      if (!!(window.history && history.pushState) === true) {
        $(options.parameters).each(function() {

          // Call function to remove parameter.
          removeParameter($(this).selector);


        });
      }
    }

    // Removes the specified parameter of the url.
    function removeParameter(parameter) {

      var url = document.location.href;
      var urlparts = url.split('?');

      if (urlparts.length >= 2) {

        var urlBase = urlparts.shift();
        var queryString = urlparts.join("?");
        var prefix = encodeURIComponent(parameter) + '=';
        var pars = queryString.split(/[&;]/g);

        for (var i = pars.length; i-- > 0;)

          if (pars[i].lastIndexOf(prefix, 0) !== -1)
            pars.splice(i, 1);

        url = urlBase + '?' + pars.join('&');
        window.history.replaceState(history.state, document.title, url);

      }

      return url;

    }

    init();
  }

  OverwritingUrl.noConflict = function noConflict() {
    global.OverwritingUrl = previouscallOverwritingUrl;
    return OverwritingUrl;
  };

  global.OverwritingUrl = OverwritingUrl;

}(this);
